import React from 'react';
import '../../css/LeaveQuota.css';
import { useTranslation } from 'react-i18next';
import { faBell, faCalendar, faCheckCircle, faTimesCircle, faUser } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LeaveQuota = ({ data, language, onSendMessage }) => {
    const { t } = useTranslation();

    const formatNumber = (number) => {
        return parseInt(number).toLocaleString(language, { maximumFractionDigits: 0 });
    };

    const items = [
        { id: 1, status: "02" },
        { id: 2, status: "03" },
        { id: 3, status: "others" }
    ];

    const iconMap = {
        "02": "/plain.svg",
        "03": '/time-fast.svg',
        "others": '/show-more.svg'
    };


    return (
        <>
            {data?.length > 0 ? (
                <ul className="leave-balance-list">

                    {data.map((leave, index) => (
                        <li key={index} className="leave-balance-item">
                            <div className="leave-balance-item-img">
                                <img
                                    src={iconMap[["02", "03"].includes(leave.TimeAccountTypeCode) ? leave.TimeAccountTypeCode : 'others']}
                                    className="text-gray-700 w-8 h-8"
                                />
                            </div>
                            <div className="title">{leave.TimeAccountTypeName}</div>
                            <div className="value">{formatNumber(leave.BalanceAvailableQuantity)} {t('D')}</div>
                            <div className="hint">
                                {t('From')} {formatNumber(leave.BalanceEntitlementQuantity)} /{t('Days')}

                            </div>
                        </li>
                    ))}
                </ul>) : (
                <p>{t("Sorry, you don't have leave balance")}</p>
            )}
        </>

    );
};

export default LeaveQuota;
